import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-semibold transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 uppercase tracking-widest",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-background hover:bg-primary/90 shadow-[0_0_20px_rgba(0,230,118,0.2)]",
        outline:
          "border border-primary bg-transparent text-primary hover:bg-primary/10",
        secondary:
          "bg-card text-white border border-border hover:border-primary",
        ghost: "text-muted-foreground hover:text-white hover:bg-white/5",
        link: "text-primary underline-offset-4 hover:underline",
        amber: "bg-accent text-background hover:bg-accent/90 font-semibold",
      },
      size: {
        default: "h-12 px-8 py-2",
        sm: "h-9 px-4 text-xs",
        lg: "h-14 px-10 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, style, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  
  // Enforce font family inline for maximum priority
  const forcedStyle = {
    fontFamily: "'Poppins', sans-serif",
    borderRadius: '0px',
    ...style
  }

  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      style={forcedStyle}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
